// Category within a HierarchicalRefinementList, triggers the respective flyout
// on click/hover interactions

import React from "react";
import PropTypes from "prop-types";

import { XS_PIXEL_MAX } from "constants/breakpoints";
import number from "helpers/number";
import Flyout from "components/search/base/Flyout";

const propTypes = {
  attribute: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  handleRefine: PropTypes.func.isRequired,
  items: PropTypes.array,
  label: PropTypes.string.isRequired,
  showFlyout: PropTypes.bool,
  value: PropTypes.string.isRequired
};

const defaultProps = {
  handleClick: () => {},
  items: [],
  showFlyout: false
};

const HierarchicalRefinementListElement = (props) => {
  // Set up count labels and respective CSS classes
  let itemsToCount = props.items.filter((item) => item.isRefined);
  const refinedCount = itemsToCount.length;

  if (refinedCount === 0) itemsToCount = props.items;

  const hitCount = itemsToCount.reduce(
    (accumulator, currentVal) => accumulator + currentVal.count,
    0
  );
  let liClassName =
    "refinement-list__element refinement-list__element--hierarchical";

  if (hitCount === 0) liClassName += " refinement-list__element--disabled";
  if (props.showFlyout) liClassName += " refinement-list__element--active";

  let elementCountClassName = "refinement-list__element-count";
  if (refinedCount > 0)
    elementCountClassName += " refinement-list__element-count--refined";

  return (
    <li key={props.value} className={liClassName}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        className="refinement-list__element-subcontainer"
        onMouseEnter={() => {
          if (window.innerWidth <= XS_PIXEL_MAX) {
            return;
          }
          props.handleClick(props.value);
        }}
        onClick={() => {
          props.handleClick(props.value);
        }}
        role="button"
        tabIndex="-1"
      >
        {props.label}
        <span className="refinement-list__element-right-side">
          {refinedCount > 0 && (
            <span className="refinement-list__num-applied">
              {refinedCount} applied
            </span>
          )}
          <span className={elementCountClassName}>
            {number.commaSeparateNumber(hitCount)}
          </span>
          <i className="lc-icon lc-icon-right lc-icon-xs refimement-list__expand-icon" />
        </span>
      </div>

      <Flyout
        attribute={props.attribute}
        category={props.value}
        currentRefinement={props.currentRefinement}
        hidden={!props.showFlyout}
        hideFlyout={() => props.handleClick(null)}
        hideFlyoutHover={() => {
          if (window.innerWidth <= XS_PIXEL_MAX) {
            return;
          }

          props.handleClick(null);
        }}
        items={props.items}
        refine={props.handleRefine}
      />
    </li>
  );
};

HierarchicalRefinementListElement.propTypes = propTypes;
HierarchicalRefinementListElement.defaultProps = defaultProps;

export default HierarchicalRefinementListElement;
